
import { Navigate } from 'react-router-dom';
import { getCurrentUser, canAccessResource, Resource } from '../utils/permissions';

interface ProtectedRouteProps {
  children: React.ReactNode;
  resource?: Resource;
  fallbackPath?: string;
}

export const ProtectedRoute = ({ 
  children, 
  resource, 
  fallbackPath = '/programs' 
}: ProtectedRouteProps) => {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // If a resource is specified, check if the user has access
  if (resource) {
    const user = getCurrentUser();
    if (!canAccessResource(user, resource)) {
      // Redirect to a page they have access to
      return <Navigate to={fallbackPath} replace />;
    }
  }

  return <>{children}</>;
};
